
import { create } from 'zustand';

export interface ApiKey {
  id: string;
  name: string;
  key: string;
  lastUsed: string | null;
  createdAt: string;
}

export interface UsageData {
  periodStart: string;
  periodEnd: string;
  totalUsage: number;
  totalCost?: number; 
  dailyUsage: Array<{
    date: string;
    count: number;
  }>;
  balance: number;
}

interface AccountState {
  apiKeys: ApiKey[];
  usage: UsageData | null;
  isLoading: boolean;
  error: string | null;
  
  setApiKeys: (keys: ApiKey[]) => void;
  addApiKey: (key: ApiKey) => void;
  removeApiKey: (id: string) => void;
  setUsage: (usage: UsageData) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
}

const useAccountStore = create<AccountState>((set, get) => ({
  apiKeys: [],
  usage: null,
  isLoading: false,
  error: null,
  
  setApiKeys: (apiKeys) => set({ apiKeys }),
  
  addApiKey: (key) => set({ 
    apiKeys: [...get().apiKeys, key] 
  }),
  
  removeApiKey: (id) => set({ 
    apiKeys: get().apiKeys.filter(key => key.id !== id) 
  }),
  
  setUsage: (usage) => set({ usage }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
}));

export default useAccountStore;
